import { connect } from 'react-redux';
import UserManagementPage from '../components/UserManagementPage';
import {
  fetchUsersAsync,
  usersSelector,
  updateUserAsync,
  removeUserAsync,
} from '../../../lib/dataLayer';

const mapStateToProps = state => ({
  users: usersSelector(state),
});

const mapDispatchToProps = {
  onMount: fetchUsersAsync,
  onChangeStatus: updateUserAsync,
  onDelete: removeUserAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserManagementPage);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/containers/UserManagementContainer.js